// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4":"909e466f","206":"f87dff80"}[chunkId] + ".js";
};